import React from 'react';
import { useAppSelector } from '@shared/hooks/use-app-selector';
import { StyleProvider } from './StyleProvider';
import { MessageDisplayer } from '@shared/components/MessageDisplayer';

export function DesignSystemProvider({ children }: React.PropsWithChildren) {
  const initialization = useAppSelector(
    (state) => state.initialization as { success?: boolean } | undefined
  );

  if (!initialization?.success) {
    return <>{children}</>;
  }

  const AntdProvider = require('./AntdProvider').AntdProvider;
  return (
    <AntdProvider>
      <StyleProvider>
        <MessageDisplayer />
        {children}
      </StyleProvider>
    </AntdProvider>
  );
}
